import React from 'react'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { API } from 'aws-amplify';
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

import DropDown from "../FormComponents/DropDown"
import TextOption from '../FormComponents/TextOption'

import { styles, translateRequestBody, validateRequestBody, stackInit } from './util'
import ScrollArrow from '../../Util/ScrollArrow'

const d = new Date()

class CMAQForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            runOption: null,
            sdate: '',
            edate:"",
            grid: "",
            requestId: null,            
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        // Avoid setting the state after the component was unmounted
        // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.type === 'radio' ? target.attributes.radioname.value : target.name;

        this.setState({
            [name]: value
        });
    }

    api_post_cmaq(request) {
        let options = {
            body: request,
            headers: {},
            response: true
        }

        this.setState({requestId: 'Loading'});

        API.post("AQcast", "/request/model/", options)
            .then(response => {
                this._isMounted && this.setState({requestId: response.data.requestId});
            })
            .catch(error => {
                this._isMounted && this.setState({validationError: 'error.errorMessage'});
                console.log(error)
            })
    }

    handleSubmit(event) {
        event.preventDefault()
        // Check if the user has left any necessary fields blank
        const errorString = validateRequestBody(this.state)
        if (errorString) {
            this.setState({
                validationError: errorString
            })
            // alert(errorString);
        } else {    // Submit normally
            this.setState({
                validationError: errorString
            })

            const requestBody = translateRequestBody(this.state)
            this._isMounted && this.api_post_cmaq(requestBody)
        }
        event.preventDefault();
    }

    displayJobResultLink(){
        if (this.state.requestId === null){
            return null
        } else if (this.state.requestId === undefined) {
            return (
                <b style={{color: 'red'}}>
                    Meteorological Allowances = 0  (purchase more or use met from previous run.)
                </b>
            )
        } else if (this.state.requestId ==='Error') {
            return (
                <b style={{color: 'red'}}>
                    Error submitting job
                </b>
            )
        } else if (this.state.requestId ==='Loading') {
            return (
                <span >
                    Submitting Job...
                </span>
            )
        } else {
            return (
                <span>
                    <Button
                        className={classNames(this.props.margin)}
                        variant="text"
                        color="default"
                        component={Link}
                        target="_blank"
                        to={{
                            pathname: '/CMAQ/Results',
                            search: '?requestId=' + this.state.requestId
                        }}
                    > Click here to view results of job: {this.state.requestId} </Button>
                    <div><i>Your run has been submitted.  You will receive an email when the project has finished.</i></div>
                    <div><i>In the meantime, you may navigate to other pages or logout of AQcast.</i></div>
                </span>
            )
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <form onSubmit={this.handleSubmit} >
                <div> <b>CMAQ</b></div>
                <div> Regrid and download CrIS emissions for use in another model.</div>
                <DropDown
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='Model Format Option:'
                    name='runOption'
                    value={this.state.runOption}
                    dropdownOptions={
                        [{
                            value: "cmaq",
                            label: "SMOKE emissions for use in CMAQ"
                        }, {
                            value: "camx",
                            label: "CAMx Model"
                        }]
                    }
                    tooltip={[<div key='runOption0'><b>stuff</b> Info about stuff.</div>]}
                />
                <div className="form-input-container">
                    <TextOption
                        classes={classes}
                        handleInputChange={this.handleInputChange}
                        title='Start Date:'
                        name='sdate'
                        maxLength='20'
                        width='200px'
                        value={this.state.sdate}
                        placeholder='Example: 2017040100'
                        tooltip={[<div key='sdate'>Format: YYYYMMDDHH (local hour)</div>]}
                    />
                    <TextOption
                        classes={classes}
                        handleInputChange={this.handleInputChange}
                        title='End Date:'
                        name='edate'
                        maxLength='20'
                        width='200px'
                        value={this.state.edate}
                        placeholder='Example: 2017050100'
                        tooltip={[<div key='edate'>Format: YYYYMMDDHH (local hour)</div>]}
                    />
                </div>
                <TextOption
                    classes={classes}
                    handleInputChange={this.handleInputChange}
                    title='Grid'
                    name='grid'
                    maxLength='20'
                    width='200px'
                    value={this.state.grid}
                    placeholder='Example: stuff'
                    tooltip={[<div key='runPeriod0'>grid extent to query data.</div>]}
                />

                <Button
                    className={classNames(classes.margin, classes.textField)}
                    type="submit"
                    variant="contained"
                    color="primary"> Submit
                </Button>
                {this.displayJobResultLink()}
                <b style={{color:'red'}}>{this.state.validationError}</b>

            </form>
        )}
}


CMAQForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CMAQForm);
